<template>
  <b-modal
    id="view_recurrence"
    title="Recorrência"
    hide-footer
    @show="resetModal()"
    @shown="
      get();
      $refs.autofocus.focus();
    "
    @hidden="resetModal()"
  >
    <b-overlay :show="loading" opacity="0.99">
      <form @submit="update">
        <WarningRequiredFields v-if="permissions.care_recurrence.edit" />
        <ErrorsMessages :errors="errors" />
        <div class="form-group">
          <LabelRequiredField label="Nome" />
          <input
            :disabled="!permissions.care_recurrence.edit"
            type="text"
            ref="autofocus"
            class="form-control"
            v-model="name"
          />
        </div>
        <div class="form-group">
          <h6>
            <span class="text-muted">Criação:</span>
            {{ formatDate(recurrence.created_at) }}
          </h6>
          <h6>
            <span class="text-muted">Última alteração:</span>
            {{ formatDate(recurrence.updated_at) }}
          </h6>
        </div>
        <div class="form-group text-right">
          <v-btn class="v-primary" @click="$bvModal.hide('view_recurrence')">
            <span class="fa fa-arrow-left"></span> Voltar
          </v-btn>
          <v-btn
            v-if="permissions.care_recurrence.remove"
            class="v-danger"
            @click="
              dialogConfirm(
                'Tem certeza que deseja remover essa recorrência?',
                function () {
                  remove();
                }
              )
            "
          >
            <span class="fa fa-times-circle"></span> Apagar
          </v-btn>
          <v-btn
            v-if="permissions.care_recurrence.edit"
            type="submit"
            class="v-success"
          >
            <span class="fa fa-check"></span> Salvar
          </v-btn>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import WarningRequiredFields from "../../components/WarningRequiredFields";
import ErrorsMessages from "../../components/ErrorsMessages";
import LabelRequiredField from "../../components/LabelRequiredField";

import api from "../../../services/api";
import toast from "../../../components/ToastNotification";

import { adminData, dialogConfirm } from "../../../lib/functions";
import { formatDate } from "../../../functions/format";

export default {
  name: "ViewRecurrence",
  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },
  props: {
    recurrence_id: [String, Number],
  },
  data() {
    return {
      permissions: {},
      errors: [],

      loading: false,

      name: "",
      recurrence: {},
    };
  },
  created() {
    this.permissions = adminData().permissions;
  },
  methods: {
    formatDate,
    dialogConfirm,
    async resetModal() {
      this.name = "";
      this.recurrence = {};
    },
    async get() {
      try {
        this.loading = true;

        let params = { id: this.recurrence_id };
        let response = await api.get("/admin/care/recurrence", {
          params,
        });
        let { error, errors, recurrence } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.recurrence = recurrence;
          this.name = recurrence.name;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update(ev) {
      try {
        ev.preventDefault();
        this.loading = true;

        let params = { id: this.recurrence_id, name: this.name };
        let response = await api.patch("/admin/care/recurrence", params);
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("view_recurrence");
          this.$emit("updated");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async remove() {
      try {
        this.loading = true;

        let params = { id: this.recurrence_id };
        let response = await api.delete("/admin/care/recurrence", params);
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("updated");
          this.$bvModal.hide("view_recurrence");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>